module.exports = __webpack_public_path__ + "e182963f1bf2e6ddf6a89feed36c73df.svg";